import { AutogenModelProspect, AutogenRowProspect } from "./autogen/AutogenModelProspect";

export class ModelProspect extends AutogenModelProspect<RowProspect> {
	constructor() {
		super(RowProspect);
	}
}

export class RowProspect extends AutogenRowProspect {
}